import { render, staticRenderFns } from "./DetailOdd.vue?vue&type=template&id=e934bc94&"
import script from "./DetailOdd.vue?vue&type=script&lang=js&"
export * from "./DetailOdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports